import React from 'react';
import _ from 'lodash';
import RichText from '../RichText';

const ContactBlocks = ({ entity }) => {

  const getContent = (title, icon, body) => {
    return (
      <>
        {title && (
          <div className="cardTitle">
            {icon && <img src={icon} alt=""/>}
            <h2>{title}</h2>
          </div>
        )}
        <RichText body={body} />
      </>
    )
  }
  return (
    <div className="contact-cards">
      {entity.fieldItems.map(card => {
        const icon = _.get(card, 'entity.fieldIcon.entity.fieldMediaIcon.entity.uri.url')
        const title = _.get(card, 'entity.fieldTitle')
        const body = _.get(card, 'entity.fieldBody.processed')
        const moreLink = _.get(card, 'entity.fieldMoreLink')
        const moreLinkLabel= _.get(entity, 'fieldMoreLinkLabel', null)

        if (moreLink) {
          return (
            <a className="contact-card" key={card.entity.entityId} href={_.get(moreLink, 'url.path')} label={moreLinkLabel}>
              {getContent(title, icon, body)}
            </a>
          )
        }

        return (
          <div className="contact-card" key={card.entity.entityId} label={moreLinkLabel} aria-label={title}>
            {getContent(title, icon, body)}
          </div>
        )
    })}
    </div>
  );
}
export default ContactBlocks;
